// Site/SiteForm/RequiredFieldMarker.jsx
import React from "react";

const RequiredFieldMarker = () => (
  <span className="text-red-500 ml-1" aria-label="required field">*</span>
);

export default RequiredFieldMarker;
